// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1O2KD","signatureBlock":"Footer_signatureBlock__9WWgC","signature":"Footer_signature__2Tm4H"};